import config from 'constants/config'
import useOptimizelyExperiment from 'hooks/Optimizely/useOptimizelyExperiment'
import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { isTourV2OrderItem } from 'lib/order/orderUtils'
import { ITEM_STATUS_AWAITING_DATES } from 'constants/cart'

/**
 * Pure eligibility check for the TripChat-from-order flow.
 * Does NOT check feature flags — call separately or use the hook wrapper.
 */
export function isOrderEligibleForChatTrip(order: App.Order): boolean {
  const isTourOrder = order.items.some(item => isTourV2OrderItem(item))
  if (isTourOrder) return false

  const hasAnyBNBLItems = order.items.some(
    item => item.status === ITEM_STATUS_AWAITING_DATES || !item.reservationMade,
  )
  if (hasAnyBNBLItems) return false

  if (order.orderGift) return false

  return true
}

/**
 * Determines whether an order is eligible for the TripChat-from-order flow.
 *
 * More permissive than `useOrderSupportsTripGeneration` (the classic V1 flow):
 * - Supports multi-hotel orders (no single-accommodation restriction)
 * - No geocoding / blacklist check needed
 * - Gated by the `trpTripChatPage` flag instead of `isGeneratedTripsEnabled`
 */
export function useOrderSupportsChatTripGeneration(order: App.Order): boolean {
  const isChatTripPageEnabled = !!useOptimizelyExperiment(
    OptimizelyFeatureFlags.trpTripChatPage,
  )

  if (!config.ENABLE_TRIP_PLANNER) return false
  if (!isChatTripPageEnabled) return false

  return isOrderEligibleForChatTrip(order)
}
